import React, { useEffect, useRef } from "react";
import simulateClick from '../utilities/simulateClick'
import { Course } from "../../compilers/course";
import { Chapter } from "../../compilers/chapter";
import '../../stylesheet/components/course/CourseInfo.scss';

type CourseInfoProps = {
  course: Course;
  setCurrentChapter: (index: number) => void;
  currentChapterIndex: number;
};

const CourseInfo: React.FC<CourseInfoProps> = ({
  course,
  setCurrentChapter,
  currentChapterIndex,
}) => {
  const loadingYellow = useRef<HTMLDivElement>(null);
  const scrollToTop = () => window.scrollTo({ top: 0, behavior: "smooth" });
  const currentIndex = currentChapterIndex;
  const allIndex = course.data.body.length;

  const handleClickChapter = (chapter:Chapter) => {
    const ModalClostBtn:HTMLButtonElement = document.querySelector("[data-bs-dismiss='modal']");
    simulateClick(ModalClostBtn);
    setCurrentChapter(chapter.index);
    scrollToTop();
  }
  const getClickableChapters = () => {
    return course.data.body.map((chapter: Chapter, i: number) => (
      <div
        key={i}
        className={`chapter-wrapper__module card ${currentChapterIndex === chapter.index ? "active-chapter" : ""}`}
        onClick={() => handleClickChapter(chapter)}
      >
        <span>{chapter.index}.</span> <span>{chapter.title}</span>
      </div>
    ));
  };

  /**
   * This effect is to track the current loading bar to check what chapter user is currently on
   * Logic: current progress of the loading bar will be tracked by the current index divided by the length of all the chapter. Then we multiple by 100 to get the percentage.
   * Then update this percentage to the width of the bar
   */
  useEffect(() => {
    const currentProgress = (currentIndex / allIndex) * 100;
    loadingYellow.current?.style.setProperty("width", currentProgress+"%");
  })

  return (
    <>
      <div className="chapter-wrapper__loading-bar my-2">
        <div ref={loadingYellow} className="yellow-load"></div>
      </div>
      <div className="chapter-wrapper">
        {getClickableChapters()}
      </div>
    </>
  )
};

export default CourseInfo;
